import React, { useState } from "react";
import {
  Button,
  // CardBody,
  // Col,
  // Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
} from "reactstrap";
import Checkbox from "../../../src/components/@vuexy/checkbox/CheckboxesVuexy";
import { Check } from "react-feather";
import "./Login.scss";
import swal from "sweetalert2";
import { login } from "../../api/controller/AuthController";
import {
  BackgrounLogin,
  EyeBlack,
  IconEyeCrossedBlack,
  LogoFuntravia,
} from "../../assets/img";
import { colors } from "../../values/colors";
import secureLocalStorage from "react-secure-storage";
import Loading from "@utils/Loading";
import { ErrorPopup } from "@utils/Helper/PopUpNotif";

export default function Login() {
  const [loading, setLoading] = useState(false);
  let [state, setState] = useState({
    email: "",
    password: "",
    msg: "",
  });

  let [hidden, setHidden] = useState(true);

  let [error, setError] = useState({
    email: false,
    password: false,
  });

  const handleChange = (name) => (event) => {
    const emailRegx =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setState({ ...state, [name]: event.target.value });
    if (name === "email") {
      let check = state[name].match(emailRegx) ? true : false;
      setError({
        ...error,
        [name]: event.target.value.length > 0 ? false : true,
      });
      if (!check) {
        // document.getElementById(name).focus();
        return false;
      }
    }
  };

  const handleSubmit = async () => {
    var check = Object.assign({}, state);
    delete check.msg;
    const emailRegx =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    for (let i in check) {
      if (i === "email") {
        let check = state[i].match(emailRegx) ? true : false;
        setError({ ...error, [i]: !check });
        if (!check) {
          document.getElementById(i).focus();
          return false;
        }
      }
    }
    try {
      setLoading(true);
      let result = await login(state);

      if (result.code === 200) {
        secureLocalStorage.setItem("token", result.token.original.access_token);
        secureLocalStorage.setItem("user", JSON.stringify(result.user));
        secureLocalStorage.setItem("menu", JSON.stringify(result.menu));
        secureLocalStorage.setItem("role", JSON.stringify(result.role));
        window.location.href = result.menu[0].navLink;
      } else {
        await swal.fire({
          title: "Login failed!",
          text: "Please check your email and password",
          icon: "error",
        });
      }
    } catch (error) {
      ErrorPopup(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleKeyPressEmail = (event) => {
    if (/[A-Z]/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div className="body login">
      {loading ? <Loading /> : null}
      <div className="d-flex" style={{ height: "100vh" }}>
        <div style={{ width: "60%" }}>
          <img
            src={BackgrounLogin}
            alt="bg-login"
            width={"100%"}
            height={"100%"}
            style={{ objectFit: "cover", objectPosition: "bottom" }}
          />
        </div>
        <div
          className="d-flex align-items-center"
          style={{ width: "40%", backgroundColor: "white", overflowY: "auto" }}
        >
          <div className="my-4 py-4" style={{ width: "100%" }}>
            <div className="text-center mb-3">
              <div>
                <img
                  src={LogoFuntravia}
                  alt="logo-funtravia"
                  width={280}
                  height={57}
                />
              </div>
              <label
                className="font-weight-bold"
                style={{ fontSize: "20px", marginTop: "20px" }}
              >
                Funtravia Booking Management System
              </label>
            </div>
            <div className="px-5">
              <Label className="font-weight-bold title">Sign In</Label>
              <p>Welcome back</p>
              <div>
                <FormGroup className="w-100">
                  <div className="text-left">
                    <Label className="font-weight-bold">Email</Label>
                  </div>
                  <Input
                    id={"email"}
                    invalid={error.email}
                    type="email"
                    placeholder="Email"
                    value={state.email}
                    onChange={handleChange("email")}
                    onKeyPress={handleKeyPressEmail}
                  />

                  <div className="invalid-feedback text-left">
                    Please enter your email.
                  </div>
                </FormGroup>
                <FormGroup className="w-100">
                  <div className="text-left">
                    <Label className="font-weight-bold">Password</Label>
                  </div>
                  <InputGroup>
                    <Input
                      type={hidden ? "password" : "text"}
                      placeholder="Password"
                      id="password"
                      onChange={handleChange("password")}
                      onKeyPress={handleKeyPress}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText onClick={() => setHidden(!hidden)}>
                        <img
                          src={hidden ? IconEyeCrossedBlack : EyeBlack}
                          alt="Eye"
                          width={20}
                          height={20}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>

                  <div className="invalid-feedback text-left">
                    Please enter your password.
                  </div>
                </FormGroup>
                <FormGroup className="w-100">
                  <Checkbox
                    color="primary"
                    icon={<Check className="vx-icon" size={16} />}
                    label="Remember me"
                    defaultChecked={false}
                  />
                </FormGroup>

                <Button
                  block
                  type="button"
                  color=""
                  onClick={handleSubmit}
                  style={{
                    color: "#fff",
                    backgroundColor: colors.green,
                  }}
                >
                  Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
